import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import useCostCodeEnabled from 'hooks/settings/useCostCodeEnabled/useCostCodeEnabled';
import { IChildrenProps } from 'types/ChildrenProps';

function CostCodeConditionalContainer({ children }: IChildrenProps) {
  return <ConditionalContainer condition={useCostCodeEnabled()}>{children}</ConditionalContainer>;
}

export default CostCodeConditionalContainer;
